var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-string",domProps:{"innerHTML":_vm._s(_vm.textResult)},on:{"click":_vm.triggerClick}})}
var staticRenderFns = []

export { render, staticRenderFns }